











































import Vue from 'vue';
import * as relazioneMedicaSpesaApi from '../../services/relazione-medica-spesa-api';
import { RelazioneMedicaSpesaEditViewModel } from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';

export default Vue.extend({
    mixins: [validationRulesMixin],
    props: {
        id: { default: 0 },
        relazioneMedicaId: { type: Number, required: true },
    },
    data(): RelazioneMedicaSpesaEditViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
        getRelazioneMedicaId(): number {
            return (
                this.relazioneMedicaId ??
                (this.item != null ? this.item.relazioneMedicaId : null)
            );
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await relazioneMedicaSpesaApi.getByKey(id);
            } else {
                this.setNewItem();
            }
        },
        close() {
            this.$emit('close');
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                importo: 0,
                note: '',
                relazioneMedicaId: this.getRelazioneMedicaId,
            };
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await relazioneMedicaSpesaApi.create(this.item);
            } else {
                response = await relazioneMedicaSpesaApi.update(this.item);
            }
            await this.loadData(response.id);
            this.$emit('save', this.item);
        },
    },
    async mounted() {
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
    watch: {
        id: {
            handler: async function (val) {
                await this.loadData(val);
            },
            immediate: true,
        },
    },
});
